angular.module('aprima-provider-api')
    .factory('MetadataService',
    [function () {
        'use strict';

        function getObjectFromMetadata(metadata, attrs) {
            if (!metadata) return;

            var model = attrs.ngModel,
                stack = model.split('.'),
                obj = metadata.Fields;

            stack.shift();

            obj = stack.reduce(function (obj, prop) {
                if (obj && obj.hasOwnProperty(prop)) {
                    return obj[prop];
                }
                return obj;
            }, obj);

            return obj ? obj : false;
        }

        //will convert the string from ngModel to a string which is used to get metadata
        //For example: ng-model="someObj.SomeField" -> "metadata.Fields.SomeField"
        function convertNgModelExprToMetadataExpr(ngModelExpr) {
            if(!ngModelExpr) return;

            var stack = ngModelExpr.split('.');

            if(stack.length === 2) {
                return 'metadata.Fields.' + stack[1];
            }

            //cannot convert it to ngModel expression
            return null;
        }

        return {
            getObjectFromMetadata: getObjectFromMetadata,
            convertNgModelExprToMetadataExpr: convertNgModelExprToMetadataExpr
        };
    }]);